import script from "./AccountManager.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountManager.vue?vue&type=script&setup=true&lang=js"

import "./AccountManager.vue?vue&type=style&index=0&id=c105b4fe&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c105b4fe"]])

export default __exports__